import React, { useEffect, useState } from 'react';
import {
  Table,
  Space,
  Button,
  Avatar,
  Tag,
  Popconfirm,
  Modal,
  Form,
  Input,
  Grid,
  Upload,
  message,
  Dropdown,
  Menu,
  Select,
  Typography,
  List,
  Card,
} from 'antd';
import {
  UsergroupAddOutlined,
  EllipsisOutlined,
  MessageOutlined,
  DeleteOutlined,
  EditOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

const { useBreakpoint } = Grid;
const { Search } = Input;
const { Title } = Typography;

const Usuarios = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [usuarios, setUsuarios] = useState([]);
  const [usuariosFiltrados, setUsuariosFiltrados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
const [loadingUsuarios, setLoadingUsuarios] = useState(new Set());

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get('https://elarigestion-production.up.railway.app/api/usuarios', {
        headers: { Authorization: token },
      });
      const usuariosFiltrados = res.data.filter((item) => item.role === 'cliente');
      setUsuarios(usuariosFiltrados);
      setUsuariosFiltrados(usuariosFiltrados);
    } catch (error) {
      Modal.error({
        title: 'Error al cargar los usuarios',
        content: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value.toLowerCase());
    const filtered = usuarios.filter((usuario) =>
      usuario.nombre_completo?.toLowerCase().includes(value) ||
      usuario.correo_electronico?.toLowerCase().includes(value) ||
      usuario.celular?.toLowerCase().includes(value) ||
      usuario.ciudad?.toLowerCase().includes(value) ||
      usuario.provincia?.toLowerCase().includes(value) ||
      usuario.direccion?.toLowerCase().includes(value)
    );
    setUsuariosFiltrados(filtered);
  };

const cambiarEstado = async (id, estadoActual) => {
  const nuevoEstado = estadoActual === 'activo' ? 'pendiente' : 'activo';
  const token = localStorage.getItem('token');

  // Añadimos el id al conjunto de loading
  setLoadingUsuarios(prev => new Set(prev).add(id));

  try {
    await axios.put(`https://elarigestion-production.up.railway.app/api/usuario/${id}`, {
      estado_de_la_cuenta: nuevoEstado,
    }, {
      headers: { Authorization: token },
    });

    message.success(`Estado actualizado a ${nuevoEstado}`);
    fetchUsuarios(); // Recargar la lista
  } catch (error) {
    console.error(error);
    message.error('No se pudo actualizar el estado');
  } finally {
    // Quitamos el id del conjunto de loading
    setLoadingUsuarios(prev => {
      const newSet = new Set(prev);
      newSet.delete(id);
      return newSet;
    });
  }
};



  const columns = [
    {
      title: 'Foto',
      dataIndex: 'avatar',
      key: 'avatar',
      render: (avatar, record) =>
        avatar ? (
          <Avatar src={avatar} alt="avatar" />
        ) : (
          <Avatar style={{ backgroundColor: record.color_del_fondo }}>
            {record.nombre_completo
              ? record.nombre_completo.charAt(0).toUpperCase()
              : '-'}
          </Avatar>
        ),
    },
    {
      title: 'Nombre Completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
      sorter: (a, b) => a.nombre_completo.localeCompare(b.nombre_completo),
    },
    {
      title: 'Celular',
      dataIndex: 'celular',
      key: 'celular',
      sorter: (a, b) => a.celular.localeCompare(b.celular),
    },
    {
      title: 'Correo Electrónico',
      dataIndex: 'correo_electronico',
      key: 'correo_electronico',
      sorter: (a, b) => a.correo_electronico.localeCompare(b.correo_electronico),
    },
    {
      title: 'Contraseña',
      dataIndex: 'contraseña_no_encriptada',
      key: 'contraseña_no_encriptada',
      sorter: (a, b) => a.contraseña_no_encriptada.localeCompare(b.contraseña_no_encriptada),
    },
    {
      title: 'Estado',
      dataIndex: 'estado_de_la_cuenta',
      key: 'estado_de_la_cuenta',
      sorter: (a, b) => a.estado_de_la_cuenta.localeCompare(b.estado_de_la_cuenta),
      render: (estado) => (
        <Tag color={estado === 'activo' ? 'green' : 'orange'}>{estado.toUpperCase()}</Tag>
      ),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <Space>
     <Button
  type={record.estado_de_la_cuenta === 'activo' ? 'default' : 'primary'}
  loading={loadingUsuarios.has(record.id)}
  onClick={() => cambiarEstado(record.id, record.estado_de_la_cuenta)}
>
  {record.estado_de_la_cuenta === 'activo' ? 'Marcar Pendiente' : 'Activar'}
</Button>

        </Space>
      ),
    },
  ];

const exportToExcel = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Usuarios');

  worksheet.columns = [
    { header: 'Nombre Completo', key: 'nombre_completo', width: 30 },
    { header: 'Correo Electrónico', key: 'correo_electronico', width: 40 },
    { header: 'Celular', key: 'celular', width: 20 },
  
    { header: 'Tipo de Negocio', key: 'tipo_de_negocio', width: 30 },
    { header: 'Estado', key: 'estado_de_la_cuenta', width: 15 },
    { header: 'Contraseña (No Encriptada)', key: 'contraseña_no_encriptada', width: 30 },
  ];

  usuariosFiltrados.forEach((usuario) => {
    worksheet.addRow({
      nombre_completo: usuario.nombre_completo || '',
      correo_electronico: usuario.correo_electronico || '',
      celular: usuario.celular || '',
   
      tipo_de_negocio: usuario.tipo_de_negocio || '',
      estado_de_la_cuenta: usuario.estado_de_la_cuenta || '',
      contraseña_no_encriptada: usuario.contraseña_no_encriptada || '',
    });
  });

  // Formatear cabecera
  worksheet.getRow(1).eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF000000' }, // negro
    };
    cell.font = {
      color: { argb: 'FFFFFFFF' }, // blanco
      bold: true,
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, 'Usuarios.xlsx');
};

  const mobileMenu = (
    <Menu>
      <Menu.Item key="excel">
        <Button
          type="primary"
          onClick={exportToExcel}
          icon={<DownloadOutlined />}
          block
        >
          Exportar Excel
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'row' : '',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: 'space-between',
          gap: '1rem',
          marginBottom: 24,
          padding: isMobile ? '20px' : 0,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <UsergroupAddOutlined style={{ fontSize: 28, color: '#1890ff' }} />
          <Title level={3} style={{ margin: 0 }}>
            Gestión de Usuarios
          </Title>
        </div>
        <Dropdown overlay={mobileMenu} trigger={['click']} visible={dropdownVisible}
          onVisibleChange={setDropdownVisible}>
          <Button icon={<EllipsisOutlined />} />
        </Dropdown>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Search
          placeholder="Buscar por nombre, correo, provincia o ciudad"
          allowClear
          enterButton="Buscar"
          size="large"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onSearch={handleSearch}
          style={{
            width: '100%',
            maxWidth: '600px',
            padding: '0 10px',
            boxSizing: 'border-box',
          }}
        />
      </div>

      {isMobile ? (
        <List
          dataSource={usuariosFiltrados}
          loading={loading}
          renderItem={(item) => (
            <Card
              style={{ marginBottom: 16 }}
              title={item.nombre_completo}
              extra={
                <a href={`https://wa.me/54${item.celular.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer">
                  <MessageOutlined style={{ color: '#25D366' }} />
                </a>
              }
            >
              <p><strong>Correo:</strong> {item.correo_electronico}</p>
              <p><strong>Celular:</strong> {item.celular}</p>
              <Button onClick={() => cambiarEstado(item.id, item.estado_de_la_cuenta)}>
                {item.estado_de_la_cuenta === 'activo' ? 'Marcar Pendiente' : 'Activar'}
              </Button>
            </Card>
          )}
        />
      ) : (
        <Table
          dataSource={usuariosFiltrados}
          columns={columns}
          rowKey="codigo"
          loading={loading}
          pagination={{ pageSize: 10 }}
          scroll={{ x: 'max-content' }}
        />
      )}
    </div>
  );
};

export default Usuarios;